export default "__VITE_PUBLIC_ASSET__4276230f__"